import corefactors from "../assets/experience/corefactors.jpg";
export const exp = [
  {
    title: "",
    date: "",
    desc: [
      ""
     
    ],
    img: corefactors
  }
];
